import {BrickSnake2000Symbol} from "./BrickSnake2000Symbol";
import {SymbolArgs} from "./BrickSnake2000Symbol"
import {BrickSnake2000} from "../../BrickSnake2000";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {BrickSnake2000GameAssets} from "../../BrickSnake2000GameAssets";

export class FreespinBlockerSymbol extends BrickSnake2000Symbol {

    public static forceSFSBlockers:boolean = false;

    // REEEEEEEE
    constructor(args:SymbolArgs) {
        const mode = BrickSnake2000.model.data.mode;
        const nextMode = BrickSnake2000.model.data.nextMode;
        args.suffix = (nextMode == GameMode.FREESPIN ||
                       (nextMode == GameMode.FREESPIN_SUPER && mode == GameMode.FREESPIN) ||
                       (mode == GameMode.FREESPIN && (nextMode == GameMode.NORMAL ||
                                                      nextMode == "GAMBLE_FIFTY_FIFTY"))) &&
                      !FreespinBlockerSymbol.forceSFSBlockers
                      ? "_FS"
                      : "_SFS";

        super(args);
    }

    public upgradeToSFS() {
        this.view.removeChild(this.spinSprite);
        this.view.removeChild(this.mainSprite)

        this.spinSprite = new PIXI.Sprite(BrickSnake2000.assetLoader.getTextures(BrickSnake2000GameAssets.getSymbolStateTexturePath("X", "_SFS_spin"))[0])
        this.spinSprite.anchor.set(0.5,0.5);
        this.mainSprite = new PIXI.Sprite(BrickSnake2000.assetLoader.getTextures(BrickSnake2000GameAssets.getSymbolStateTexturePath("X", "_SFS"))[0]);
        this.mainSprite.anchor.set(0.5,0.5);

        this.view.addChild(this.spinSprite);
        this.view.addChild(this.mainSprite);
    }
}